export default class History {
    static historyInstance = null;

    static push(page) {
        History.historyInstance.push(page);
    }

}